var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("user-gender " + (_vm.gender === 2 && 'girl'))},[_c('svg-icon',{class:"user-gender-icon",attrs:{"icon-class":_vm.gender === 2 ? 'woman' : 'man'}}),_c('div',{staticClass:"user-age"},[_vm._v(_vm._s(_vm.age))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }